/**
 * Page Statistiques GED
 * Dashboard de visualisation des statistiques de la GED
 */

import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import GEDStatistiques from '../components/GED/GEDStatistiques';

const GEDStatistiquesPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <div className="bg-white border-b">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16">
            <button
              onClick={() => navigate(-1)}
              className="flex items-center gap-2 text-gray-600 hover:text-gray-900"
            >
              <ArrowLeft className="h-5 w-5" />
              Retour
            </button>
            <h1 className="text-xl font-semibold text-gray-900">
              Gestion Électronique des Documents
            </h1>
            <div className="w-20" /> {/* Spacer for centering */}
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <GEDStatistiques />
      </div>
    </div>
  );
};

export default GEDStatistiquesPage;
